// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyProfileList_faculty-profile-list__y1csZ {
  width: 90%;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/FacultyProfileList/FacultyProfileList.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF","sourcesContent":[".faculty-profile-list {\n  width: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-profile-list": `FacultyProfileList_faculty-profile-list__y1csZ`
};
export default ___CSS_LOADER_EXPORT___;
